// Order is important!
export const COLUMNS = {
  sampleStandardDeviation: 'Standard Deviation',
  min: 'Minimum Value',
  firstQuantile: 'Q1',
  median: 'Median',
  mean: 'Mean',
  thirdQuantile: 'Q3',
  max: 'Maximum Value'
};
